import * as React from 'react';
import { useCommunityQuestionLink } from '../../../../../hooks/useCommunityQuestionLink';
import { TabContentContainer } from '../../../AppListing.styles';
import { SupportResourcesLink } from '../types';
import { Columns, LeftColumn, RightColumn } from './styles';
import { SupportContact } from './SupportContact';
import { SupportResources } from './SupportResources';
import { SupportTagline } from './SupportTagline';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SupportTab = props => {
  const {
    supportDetails,
    atlassianCommunityBaseUrl,
    mpacBaseUrl,
    hosting,
    appKey,
    onSupportLinkClick,
    cloudMigrationInfo,
    onCloudMigrationResourceLinksClick,
    onTabSelect,
    isEditionsSupported,
    appPricingDetailsLink
  } = props;
  const goToPricingTab = () => {
    onTabSelect('pricing');
  };
  const atlassianCommunityUrl = useCommunityQuestionLink({
    atlassianCommunityBaseUrl,
    mpacBaseUrl,
    appKey,
    hosting
  });
  const hasContact = supportDetails.isSupported && (supportDetails.availability || supportDetails.contact.emailId || supportDetails.contact.phoneNumber || supportDetails.contact.issueTrackerUrl || supportDetails.contact.supportTicketSystemUrl);
  return /*#__PURE__*/_jsxs(TabContentContainer, {
    children: [/*#__PURE__*/_jsx(SupportTagline, {
      supportDetails: supportDetails,
      atlassianCommunityUrl: atlassianCommunityUrl.url,
      goToPricingTab: goToPricingTab,
      isEditionsSupported: isEditionsSupported,
      onCommunityLinkClick: () => onSupportLinkClick(SupportResourcesLink.ATLASSIAN_COMMUNITY),
      appPricingDetailsLink: appPricingDetailsLink
    }), /*#__PURE__*/_jsxs(Columns, {
      children: [hasContact && /*#__PURE__*/_jsx(LeftColumn, {
        children: /*#__PURE__*/_jsx(SupportContact, {
          supportDetails: supportDetails,
          onSupportLinkClick: onSupportLinkClick
        })
      }), /*#__PURE__*/_jsx(RightColumn, {
        children: /*#__PURE__*/_jsx(SupportResources, {
          supportDetails: supportDetails,
          onSupportLinkClick: onSupportLinkClick,
          atlassianCommunityUrl: atlassianCommunityUrl.url,
          cloudMigrationInfo: cloudMigrationInfo,
          onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick
        })
      })]
    })]
  });
};